import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit, FaEye } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { MdOutlineSwapHoriz } from "react-icons/md";
import UserManagementModalContent from "./ModalContent/UserManagementModalContent";
import UserManagementViewContent from "./ModalContent/UserManagementViewContent";
import { useGetUserList } from "./SuperSettingsScreen/hook/useUserManagement";
import { useNavigate } from "react-router-dom";

type Props = {};

const userDataColumns = (
  handleEditClick: (row: any) => void,
  handleViewClick: (row: any) => void,
  handleNavigation:(row:any)=>void,
) => [
  {
    name: "Name",
    selector: (row: { Name: string }) => row.Name,
    sortable: true,
    width: "200px",
    wrap:true
  },
  {
    name: "Email",
    selector: (row: { Email: string }) => row.Email,
    sortable: true,
    width: "250px",
    wrap:true,
    cell:(row:{Email:string})=>(
    <span style={{color:'blue'}}>
      {row.Email}
    </span>
    )
  },
  {
    name: "Role",
    selector: (row: { Role: string }) => row.Role,
    sortable: true,
    width: "100px",
  },
  {
    name: "Linked to",
    selector: (row: { linked: string }) => row.linked,
    sortable: true,
    width: "180px",
    cell: (row: { linked: string }) => (
    <span
      style={{
        color:'blue',
        cursor:'pointer'
      }}
      onClick={()=>handleNavigation(row)}
    >
    {row.linked !== '' ? 'Employee' :'-' }

    </span>
   ),
  },
  {
    name: "Last login time",
    selector: (row: { LastLogin: string }) => row.LastLogin,
    sortable: true,
    width: "160px", 
    cell: (row: { LastLogin: number }) => {
    // Convert seconds to milliseconds
    const date = new Date(row.LastLogin * 1000);
    const formatted = date.toLocaleString("hi-IN",{
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
    return <span>{formatted}</span>;
  },

  },
  {
    name: "Status",
    selector: (row: { StatusValue: string }) => row.StatusValue,
    sortable: true,
    width: "100px",
  },
  {
    name: "Action",
    // width: "200px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={() => handleEditClick(row)}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} />
          Edit
        </button>

        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          onClick={() => handleViewClick(row)}
          style={{
            backgroundColor: "#2e8dd3",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      </div>
    ),
  },
];


const filterOptions = [
  {
    label: "Organization",
    options: [
      { id: "All", label: "All" },
      { id: "HR", label: "HR" },
      { id: "Finance", label: "Finance" },
      { id: "IT", label: "IT" },
    ],
  },
];

const UserManagement = (props: Props) => {
  const navigate = useNavigate();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [rowData,setrowData] = useState<any>();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };
 const [filterData,setFilterData] = useState({
  search:'',
  start:1,
  limit:10,
  sortColumn:'CreatedAt',

 })   

  const {data:UserListData,isLoading,isSuccess} = useGetUserList({enable:true,params:{
    search:filterData.search,
    start:filterData.start,
    limit:filterData.limit,
    sortColumn:filterData.sortColumn,
  }})
 
  const handleClose = () => {
    setIsEditModalOpen(false);
    setIsViewModalOpen(false);
  };
  const handleSelection = (selected: string) => {
    console.log("Selected:", selected);
  };

  const handleEditClick = (row:any) => {
    setrowData(row);
    // console.log('handleEditClick:',row);
    setIsEditModalOpen(true);
  };

  const handleViewClick = (row: any) => {
    console.log('row=========> Reset Password',row);
    setIsViewModalOpen(true);
  };
  
  const handleNavigation=(row:any)=>{
    const EmpolyeeId:number = row.linked;
    navigate('/employeeDetails',{ state: { employeeData: { EmployeeId: EmpolyeeId } }});
  }
   
  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
      limit: limit,
    }));
  };

  const handleSerach =(val:any)=>{   
  setFilterData((prev:any)=>({
         ...prev,
         search:val
    }))
  }

  return (
    <div className="p-2">
      <PageHeader
        title="User Management"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        SearchPlaceholder="Search name, email ,phone"
        Title="Users"
        data={(!isLoading && isSuccess && UserListData?.formatedData) || []}
        columns={userDataColumns(handleEditClick, handleViewClick,handleNavigation)}
        filterOptions={filterOptions}
        showSpinner={isLoading}
         onChangePage={(pageNo: number) => {
            handlePagination(pageNo);
          }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
            handleonChangeRowsPerPage(newPerPage, page);
          }}
          handleSearch={(val:any)=>handleSerach(val)}
          paginationTotalRows={(UserListData?.rowData.data.recordsTotal) || 0}
      />
      <RouteModal
        isOpen={isEditModalOpen}
        toggle={() => setIsEditModalOpen(!isEditModalOpen)}
        title="Edit Users"
        size="md"
        content={
          <UserManagementModalContent
            handleClose={handleClose}
            rowData={rowData}
          />
        }
      />
      {/* <RouteModal
        isOpen={isViewModalOpen}
        toggle={() => setIsViewModalOpen(!isViewModalOpen)}
        title="Reset Password"
        size="md"
        content={
          <UserManagementViewContent
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        }
      /> */}
    </div>
  );
};

export default UserManagement;
